import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DeviceUtility } from '../../shared/utilities/device.utility';

import swal from 'sweetalert2';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  constructor(
    private _route: ActivatedRoute,
    private _router: Router
  ) { }

  ngOnInit() {

  }

  forgotPassword(){
    this._router.navigate(['/auth/forgot_password']);
  }

  back(){
    this._router.navigate(['/auth/sign_in']);
  }

  resisterUser(){
    this._router.navigate(['/auth/register/user']);
  }

  descargaFormatoComisiones(){
    if (DeviceUtility.isMobileDevice()) {      
      var link = document.createElement('a');                          
      link.href = "./assets/files/formatoComisiones.pdf";
      link.download = "formato_comisiones.pdf";
      link.click();

    }
    else {    

      swal({
        width: 820,
        title: 'Formato de Comisiones',
        showCloseButton: true,
        html: `
        <object id="previewFormato" data="./assets/files/formatoComisiones.pdf" type="application/pdf" width="800" height="800">            
        </object>       
        `,
        confirmButtonClass: 'btn btn-primary',
        confirmButtonText: 'Cerrar',
        allowOutsideClick: false,
        buttonsStyling: false,
        focusConfirm: false
      });

    }     
  }

}



// WEBPACK FOOTER //
// /app/src/app/auth/register/register.component.ts